<template>
  <v-container fluid fill-height grid-list-md>
    <v-layout justify-center wrap>
      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar dark color="primary" flat>
            <v-toolbar-title>Ubah Outlet</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                outlined
                label="Nama Outlet"
                type="text"
                placeholder="Masukkan nama outlet"
                v-model="outletName"
                autofocus
              ></v-text-field>
              <v-text-field
                outlined
                label="Kode Outlet"
                type="text"
                placeholder="Masukkan kode outlet"
                v-model="outletCode"
              ></v-text-field>
              <v-textarea
                label="Deskripsi"
                outlined
                placeholder="Masukkan deskripsi"
                v-model="description"
              ></v-textarea>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-container fluid fill-height>
              <v-layout wrap justify-start>
                <v-flex xs12>
                  <v-divider light></v-divider>
                </v-flex>
                <v-flex xs12 class="text-right">
                  <v-btn color="tertiary" class="mr-4" dark :to="mainPath"
                    >Kembali</v-btn
                  >
                  <v-btn
                    color="secondary"
                    :loading="loading"
                    :disabled="loading"
                    @click="editData"
                    >Ubah<template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="isLoadingFinished"
      top
      :color="loadingMessageColor"
      :timeout="errorTimeout"
    >
      <span v-html="loadingMessage"></span>
      <v-btn dark text @click="isLoadingFinished = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      isLoadingFinished: false,
      loadingMessage: null,
      loadingMessageColor: "primary",
      errorTimeout: 7000,
      mainPath: process.env.VUE_APP_OUTLET_PATH,
      outletName: null,
      outletCode: null,
      description: null
    };
  },
  methods: {
    editData() {
      this.loading = true;
      this.isLoadingFinished = false;
      let self = this;
      this.axios
        .post(self.mainPath + "/edit", {
          outletName: self.outletName,
          outletCode: self.outletCode,
          description: self.description,
          id: self.$route.params.id
        })
        .then(function() {
          self.loadingMessage = "Sukses mengubah outlet";
          self.loadingMessageColor = "primary";
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
        })
        .finally(function() {
          self.loading = false;
          self.isLoadingFinished = true;
        });
    },
    fetchData() {
      let self = this;
      this.axios
        .get(self.mainPath + "/" + this.$route.params.id)
        .then(function(response) {
          let data = response.data;
          self.outletName = data.outletName;
          self.outletCode = data.outletCode;
          self.description = data.description;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    }
  },
  mounted: function() {
    this.fetchData();
  }
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
